export function originParamsFromUser(user) {
  const address = user?.default_address;

  if (address?.latitude == null || address?.longitude == null) {
    return {};
  }

  return {
    origin_lat: address.latitude,
    origin_lng: address.longitude,
  };
}

export function parseProvidersListResponse(data) {
  if (Array.isArray(data)) {
    return { providers: data, deliveryArea: null };
  }

  return {
    providers: data?.providers || [],
    deliveryArea: data?.delivery_area || null,
  };
}

export function isOutOfDeliveryArea(deliveryArea) {
  return deliveryArea?.origin_applied === true && deliveryArea?.in_range === false;
}

export function isProviderOutOfDeliveryRadius(provider, radiusKm = 30) {
  if (provider?.distance_km == null) {
    return false;
  }

  return Number(provider.distance_km) > Number(radiusKm);
}

export function getOutsideDeliveryAreaError(error) {
  const data = error?.response?.data;
  if (data?.code !== 'outside_delivery_area') {
    return null;
  }

  return {
    message: data.errors?.[0] || 'Ainda não entregamos na sua região.',
    radiusKm: data.radius_km ?? 30,
  };
}
